import contentDisposition from "content-disposition";
import { saveAs } from "file-saver";

export function saveAxiosBlobAs(response, fallbackFilename = null) {
    const contentDispositionHeader = contentDisposition.parse(response.headers["content-disposition"]);
    saveAs(response.data, contentDispositionHeader.parameters.filename ?? fallbackFilename);
}